export default () =>
  import(
    /* webpackChunkName: 'coffee/app/invite-school-season' */ './InviteSchoolSeason'
  );
